module.exports = __webpack_public_path__ + "static/img/banner.dd01642.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner.png
// module id = wHlt
// module chunks = 1